import type { ViewRecordFieldChange } from '@salescore/client-redux'
import type { ModelSearcher, ViewQueryList, ViewQueryNode, ViewQueryRecordNode } from '@salescore/core'
import { Array, Equivalence, pipe } from 'effect'
import { isNotNullish } from 'effect/Predicate'

import type { DeepReadonly } from '../../../../rsheet/types/DeepReadonly'
import { flatNodes, getRecordNodeFromRootNodePure } from '../../../../state/nodeUtility'

// eslint-disable-next-line @typescript-eslint/max-params
export function generateDeleteChangesPure(
  query: DeepReadonly<ViewQueryList>,
  targetNode: DeepReadonly<ViewQueryNode>,
  recordNode: DeepReadonly<ViewQueryRecordNode>,
  modelSearcher: ModelSearcher,
  isDeleteAllChildren?: boolean,
): ViewRecordFieldChange[] {
  if (targetNode.write === undefined) {
    return []
  }

  if (isDeleteAllChildren !== true) {
    const model = modelSearcher.searchModel(targetNode.write.streamName)
    if (!(model?.deletable ?? true)) {
      return []
    }

    return [
      {
        id: recordNode.id,
        streamName: targetNode.write.streamName,
        fieldChanges: [],
        before: {},
        after: {},
        deleted: true,
      },
    ]
  }

  const visibleNodeNames = pipe(
    query.fields,
    Array.flatMap((field) => field.nodePath),
    Array.filter(isNotNullish),
    Array.dedupe,
  )
  const nodes = flatNodes(targetNode).filter((x) => {
    const model = modelSearcher.searchModel(x.write?.streamName)
    return model?.deletable ?? visibleNodeNames.includes(x.name)
  })

  return pipe(
    nodes,
    Array.flatMap((node): ViewRecordFieldChange[] => {
      if (node.write === undefined) {
        return []
      }

      // 該当するnodeのrecordsを取得
      const recordNodes = getRecordNodeFromRootNodePure(recordNode, node.path.slice(targetNode.path.length - 1))

      if (recordNodes === undefined) {
        return []
      }

      const xs = Array.isArray(recordNodes) ? recordNodes : [recordNodes]
      const nameField = query.fields
        .filter((x) => Array.makeEquivalence(Equivalence.String)(x.nodePath, node.path))
        .find((field) => field.meta.fieldMetaType === 'name')

      // recordNodesを全て削除
      return xs.map(
        (recordNode): ViewRecordFieldChange => ({
          id: recordNode.id,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          streamName: node.write!.streamName,
          fieldChanges: [],
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
          recordNameLabel: nameField === undefined ? undefined : (recordNode.attributes[nameField.name] as string),
          // before: recordNode.attributes,
          // after: {},
          deleted: true,
        }),
      )
    }),
    Array.dedupeWith((a, b) => a.id === b.id && a.streamName === b.streamName),
  )
}
